import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { useDashboardService } from 'src/apis/dashboard/useDashboardService';
import { IInventoryDashboardData } from 'src/apis/dashboard/dashboardInventory.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getDashboardInventoryKey = 'get-dashboard-inventory';

export const useDashboardInventoryHook = (
  options?: UseQueryOptions<IInventoryDashboardData, TQueryError>
): UseQueryResult<IInventoryDashboardData, TQueryError> => {
  const { getInventoryDashboardData } = useDashboardService();

  return useQuery<IInventoryDashboardData, TQueryError>({
    queryKey: [getDashboardInventoryKey],
    queryFn: () => getInventoryDashboardData(),
    enabled: true,
    ...options,
  });
};
